import {
  BillingContextResponseSchema,
  CreateInvitationsResponseSchema,
  InvitationSchema,
  InvitationsSyncSchema,
  ProjectParticipantsResponseSchema,
  ProjectSchema,
  ProjectWithInvitesSchema,
} from "@storytell/types";
import { RequestBuilder } from "../requestBuilder";
import {
  AcceptInvitationResponseSchema,
  CreateInvitationsInputSchema,
  CreateProjectInputSchema,
  InvitationDetailSchema,
  InvitationIdParamsSchema,
  ProjectIdParamsSchema,
  ProjectsSyncSchema,
  UpdateInvitationInputSchema,
  UpdateProjectInputSchema,
} from "./projectClient.types";

export const ProjectsSyncRequestConfig = new RequestBuilder({
  path: () => "/projects-sync",
  responseSchema: ProjectsSyncSchema,
});

export const CreateProjectRequestConfig = new RequestBuilder({
  path: () => "/projects",
  responseSchema: ProjectWithInvitesSchema,
  bodySchema: CreateProjectInputSchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

export const DeleteProjectRequestConfig = new RequestBuilder({
  paramsSchema: ProjectIdParamsSchema,
  path: (params) => `/projects/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined)
  .withIncludeProjectId();

export const UpdateProjectRequestConfig = new RequestBuilder({
  paramsSchema: ProjectIdParamsSchema,
  path: ({ id }) => `/projects/${id}`,
  responseSchema: ProjectSchema,
  bodySchema: UpdateProjectInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const InvitationsSyncRequestConfig = new RequestBuilder({
  path: () => "/invitations-sync",
  responseSchema: InvitationsSyncSchema,
}).withIncludeProjectId();

export const CreateInvitationsRequestConfig = new RequestBuilder({
  path: () => "/invitations",
  responseSchema: CreateInvitationsResponseSchema,
  bodySchema: CreateInvitationsInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

// Not project-scoped: the invitation token identifies the target tenancy,
// and the accepting user may not yet have a stable URL projectId. No body: the
// server takes the accepting identity from the bearer claims, so a caller
// cannot name someone else.
export const AcceptInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}/accept`,
  responseSchema: AcceptInvitationResponseSchema,
}).withMethod("PUT");

// Readable only by the invitation's recipient; anyone else gets a not-found
// indistinguishable from an id that never existed.
export const InvitationDetailRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}`,
  responseSchema: InvitationDetailSchema,
});

export const UpdateInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}`,
  responseSchema: InvitationSchema,
  bodySchema: UpdateInvitationInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const DeleteInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}`,
})
  .withMethod("DELETE")
  .withContentType(undefined)
  .withIncludeProjectId();

export const ProjectParticipantsRequestConfig = new RequestBuilder({
  path: () => "/projects/participants",
  responseSchema: ProjectParticipantsResponseSchema,
}).withIncludeProjectId();

export const BillingContextRequestConfig = new RequestBuilder({
  path: () => "/projects/billing",
  responseSchema: BillingContextResponseSchema,
})
  .withMethod("GET")
  .withIncludeProjectId();
